import { CopyOutlined } from '@ant-design/icons'
import { useChannelStore } from '@entities/channel'
import { usePartners } from '@entities/partner'
import type { FormProps } from 'antd'
import { App, Button, Card, Col, Form, Input, Row, Space, theme, Typography } from 'antd'
import InputMask from 'react-input-mask'
import { useNavigate } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'

const { Text } = Typography

type MainFormFields = {
    name: string
    tgUsername: string
    email: string
    phone: string
    comment: string
    relatedChannel: number
}

export const MainFormMobile = () => {
    const {
        actions: { createPartner }
    } = usePartners()

    const {
        token: { colorWhite }
    } = theme.useToken()

    const { currentChannel } = useChannelStore(useShallow(({ current }) => ({ currentChannel: current })))

    const navigate = useNavigate()

    const onFinish: FormProps<MainFormFields>['onFinish'] = async (values) => {
        const partner = await createPartner(values)

        navigate(`/advertising/partners/${partner.id}`)
    }

    const [form] = Form.useForm()

    const { message } = App.useApp()

    return (
        <Form
            form={form}
            name="add-partner"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            initialValues={{
                relatedChannel: currentChannel?.id
            }}
            onFinish={onFinish}
        >
            <Form.Item name="relatedChannel" hidden />
            <Card size="small" style={{ backgroundColor: colorWhite, marginBottom: '16px' }}>
                <Row gutter={16}>
                    <Col span={'24'} style={{ marginBottom: '10px' }}>
                        <Text style={{ fontSize: '17px', color: '#8F8E94' }}>Пригласить в Telegaplan</Text>
                        <Space.Compact style={{ width: '100%', marginTop: '10px' }}>
                            <Input
                                value={`Я приглашаю тебя в ${window.location.origin}, самую удобную Crm для Telegram.`}
                                size="large"
                            />
                            <Button
                                type="primary"
                                size="large"
                                onClick={() =>
                                    navigator.clipboard
                                        .writeText(
                                            `Я приглашаю тебя в ${window.location.origin}, самую удобную Crm для Telegram.`
                                        )
                                        .then(() => {
                                            message.success('Скопировано в буфер обмена')
                                        })
                                }
                            >
                                <CopyOutlined />
                            </Button>
                        </Space.Compact>
                    </Col>
                </Row>
            </Card>
            <Card size="small" style={{ backgroundColor: colorWhite }}>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            label={<Text style={{ fontSize: '17px', color: '#8F8E94' }}>Имя</Text>}
                            name="name"
                            required={false}
                            rules={[{ required: true, message: 'Обязательное поле' }]}
                        >
                            <Input placeholder="Введите имя" size="large" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label={<Text style={{ fontSize: '17px', color: '#8F8E94' }}>Username в телеграм</Text>}
                            name="tgUsername"
                            required={false}
                            rules={[{ required: true, message: 'Обязательное поле' }]}
                        >
                            <Input placeholder="@username" size="large" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label={<Text style={{ fontSize: '17px', color: '#8F8E94' }}>E-mail</Text>}
                            name="email"
                            required={false}
                            rules={[{ required: true, message: 'Обязательное поле' }]}
                        >
                            <Input placeholder="helle@telegaplan.me" size="large" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label={<Text style={{ fontSize: '17px', color: '#8F8E94' }}>Номер телефона</Text>}
                            name="phone"
                            required={false}
                            rules={[{ required: true, message: 'Обязательное поле' }]}
                        >
                            <InputMask mask="+7(999)999-99-99">
                                {(inputProps) => (
                                    <Input {...inputProps} placeholder="Введите номер телефона" size="large" />
                                )}
                            </InputMask>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label={<Text style={{ fontSize: '17px', color: '#8F8E94' }}>Комментарий</Text>}
                            name="comment"
                            required={false}
                        >
                            <Input.TextArea placeholder="Введите текст" size="large" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <div
                            style={{
                                position: 'fixed',
                                bottom: 0,
                                left: 0,
                                padding: '8px 16px 42px 16px',
                                zIndex: 10000,
                                width: '100%',
                                backgroundColor: colorWhite,
                                borderTop: '0.5px solid #D3D3D5'
                            }}
                        >
                            <Button type="primary" htmlType="submit" size="large" style={{ width: '100%' }}>
                                Сохранить
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Card>
        </Form>
    )
}
